import { createSelector } from 'reselect';
import { RESOURCE_TYPES } from 'scenes/NewFlow/constants';
import size from 'lodash/size';
import flow from 'lodash/flow';
import get from 'lodash/get';
import { getActionType } from '../actions/selectors';

export const getFlowState = ({ newFlow }) => newFlow;

export const getCanvases = createSelector(
  getFlowState,
  state => state.canvases.data,
);

export const getCanvasesCnt = createSelector(
  getCanvases,
  data => size(data),
);

export const getCanvasesKeys = createSelector(
  getCanvases,
  data =>
    flow(
      data => Object.keys(data),
      keys => keys.map(key => parseInt(key, 10)),
    )(data),
);

export const getCanvasesById = canvasId =>
  createSelector(
    getCanvases,
    canvases => canvases[canvasId],
  );

export const getCanvasResources = canvasId =>
  createSelector(
    getCanvasesById(canvasId),
    canvas => get(canvas, 'resources', []),
  );

export const getCanvasResourcesWithSubType = canvasId => state => {
  const canvasResources = getCanvasResources(canvasId)(state);
  return canvasResources.map(resource => ({
    ...resource,
    subType:
      resource.type === RESOURCE_TYPES.ACTION
        ? getActionType(resource.id)(state)
        : '',
  }));
};

export const getCanvasConnections = canvasId =>
  createSelector(
    getCanvasesById(canvasId),
    canvas => get(canvas, 'connections', []),
  );

export const getCanvasMaxLeftPosition = canvasId =>
  createSelector(
    getCanvasResources(canvasId),
    resources => {
      if (!resources.length) {
        return 10;
      }

      const resourceWith = 300;
      const marginLeft = 50;

      return flow(
        resources =>
          resources.map(resource => parseInt(resource.position.left, 10)),
        positions => Math.max(...positions),
        max => max + resourceWith + marginLeft,
      )(resources);
    },
  );

export const getCanvasResourceUUID = (canvasId, resourceId) =>
  createSelector(
    getCanvasResources(canvasId),
    resources =>
      flow(
        resources => resources.find(resource => resource.id === resourceId),
        resource => get(resource, 'uuid', ''),
      )(resources),
  );
